import { ChevronDown, ChevronUp, ChevronsUpDown } from 'lucide-react'

interface SortableThProps {
  label: string
  field: string
  sort: string
  order: 'ASC' | 'DESC'
  onSort: (field: string) => void
  align?: 'left' | 'right'
}

/** Table header cell with click-to-sort indicator. */
export default function SortableTh({ label, field, sort, order, onSort, align = 'left' }: SortableThProps) {
  const active = sort === field
  const Icon = active ? (order === 'ASC' ? ChevronUp : ChevronDown) : ChevronsUpDown
  return (
    <th
      className={`cursor-pointer select-none px-5 py-3.5 text-${align} text-[11px] font-semibold uppercase tracking-wider text-slate-400 transition-colors hover:text-slate-600`}
      onClick={() => onSort(field)}
    >
      <span className={`inline-flex items-center gap-1 ${align === 'right' ? 'flex-row-reverse' : ''}`}>
        {label}
        <Icon size={12} className={active ? 'text-brand-600' : 'text-slate-300'} />
      </span>
    </th>
  )
}
